import script from "./NewFormRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFormRenderer.vue?vue&type=script&setup=true&lang=js"

import "./NewFormRenderer.vue?vue&type=style&index=0&id=d96dca54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d96dca54"]])

export default __exports__